/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { toast } from 'react-hot-toast';
import Loader from "../Common/Loader";
import SystemModal from "../Common/SystemModal";
import ajaxBank from "../../util/remote/ajaxBank";
import ajaxStudent from "../../util/remote/ajaxStudent";

const ActivateAccount=(props)=>{

    const [loading, setLoading] = useState(false)
    const [activationFee, setActivationFee] = useState(false)
    const [cardType, setCardType] = useState("");

    const [number, setNumber] = useState("");

    const formatPhoneNumber = (number) => {
        // Remove all non-numeric characters
        let cleaned = number.replace(/\D/g, '');

        return cleaned;
    };


    const handleUpdate = async(e) =>{
        e.preventDefault()
        if(number.length>0 || cardType.length>0){
            setLoading(true)
            const server_response = await ajaxStudent.payActivationFee(props.userID, number, cardType);
            setLoading(false);
            if(server_response.status==="OK"){
                toast.success(server_response.message);
                props.g()
            }
            else{
                toast.error(server_response.message); 
            }
        }
        else{
            toast.error("Please enter all fields!")
        }  
    }

    const getActivationFee = async () => {
        const server_response = await ajaxBank.fetchActivationFee(cardType, props.userID);
        
        if (server_response.status === "OK") {
            
            setActivationFee(server_response.details);
        }else {
            setActivationFee("404");
        }
    };

    useEffect(() => {
        getActivationFee();
      }, [cardType, props.userID]);
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                    <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                    <button 
                        type="button" 
                        className={`btn-fill-md text-light bg-dodger-blue`} 
                        onClick={handleUpdate}>Activate<i class="fas fa-check mg-l-15"></i></button>
                    </>
        }
    }

    return(
        <SystemModal
            title="Activate Account"
            id="model-pay-activation-fee"
            size="md"
            footer={RenderFooter}
        >
            <div className="mb-4 form-group border-1">
                <label htmlFor="">Type</label>
                <select
                    style={{border: "1px solid grey"}}
                    className="col-12 form-control"
                    value={cardType}
                    onChange={(e) => setCardType(e.target.value)}>
                    <option value="" selected disabled>Select type...</option>
                    <option value="ACTIVATION">Card</option>
                    <option value="WRISTBAND_ACTIVATION">Wristband</option>

                </select>
            </div>
            {cardType?<><p>Activation Fee: <b>UGX. {activationFee}</b></p>
            <div className="mb-4 form-group border-1">
                <label htmlFor="">Phone Number</label>
                <input onChange={(e)=>setNumber(formatPhoneNumber(e.target.value))} placeholder="Enter mobile money number to receive prompt..." style={{border: "1px solid grey"}} value={number} type="text" className="form-control"/>
            </div></>:""}
       
        </SystemModal>
    )
}

export default ActivateAccount
